import EcsInternalBusinessContact from './EcsInternalBusinessContact';
import { CONTACT_TYPE } from '@/constants/contactConstants';

export default class EcsSupervisor extends EcsInternalBusinessContact {
  get contactType() {
    return CONTACT_TYPE.supervisor;
  }

  get isEmailEnabled() {
    return false;
  }
}
